// Users
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
export const GET_USER_CUSTOMER_GROUPS_SUCCESS =
  'GET_USER_CUSTOMER_GROUPS_SUCCESS';
export const SET_USER_DETAILS_SUCCESS = 'SET_USER_DETAILS_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

// Roles
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const SET_ROLES_DETAILS_SUCCESS = 'SET_ROLES_DETAILS_SUCCESS';
export const GET_ROLE_PERMISSIONS_SUCCESS = 'GET_ROLE_PERMISSIONS_SUCCESS';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';

// Permissions
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const SET_PERMISSION_DETAILS_SUCCESS = 'SET_PERMISSION_DETAILS_SUCCESS';
export const DELETE_PERMISSION_SUCCESS = 'DELETE_PERMISSION_SUCCESS';

// Applications
export const GET_APPLICATIONS_SUCCESS = 'GET_APPLICATIONS_SUCCESS';
export const GET_APPLICATION_DETAILS_SUCCESS =
  'GET_APPLICATION_DETAILS_SUCCESS';
export const GET_APPLICATION_LANGUAGES_SUCCESS =
  'GET_APPLICATION_LANGUAGES_SUCCESS';
export const GET_APPLICATION_JOB_TITLES_SUCCESS =
  'GET_APPLICATION_JOB_TITLES_SUCCESS';
export const GET_APPLICATION_COUNTRIES_SUCCESS =
  'GET_APPLICATION_COUNTRIES_SUCCESS';

// Organizations
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATION_DETAILS_SUCCESS =
  'GET_ORGANIZATION_DETAILS_SUCCESS';
export const GET_ORGANIZATION_MEMBERS_SUCCESS =
  'GET_ORGANIZATION_MEMBERS_SUCCESS';
export const GET_ORGANIZATION_ADMINS_SUCCESS =
  'GET_ORGANIZATION_ADMINS_SUCCESS';
export const GET_CONNECTED_ORGANIZATIONS_SUCCESS =
  'GET_CONNECTED_ORGANIZATIONS_SUCCESS';
export const ADD_CONNECTED_ORGANIZATION_SUCCESS =
  'ADD_CONNECTED_ORGANIZATION_SUCCESS';
export const DELETE_CONNECTED_ORGANIZATION_SUCCESS =
  'DELETE_CONNECTED_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_SUCCESS = 'DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_MEMBER_SUCCESS =
  'DELETE_ORGANIZATION_MEMBER_SUCCESS';
export const DELETE_ORGANIZATION_ADMIN_SUCCESS =
  'DELETE_ORGANIZATION_ADMIN_SUCCESS';

// Groups
export const GET_CUSTOMER_GROUPS = 'GET_CUSTOMER_GROUPS';
export const GET_CUSTOMER_GROUP_DETAILS = 'GET_CUSTOMER_GROUP_DETAILS';
export const GET_CUSTOMER_GROUP_MEMBERS_SUCCESS =
  'GET_CUSTOMER_GROUP_MEMBERS_SUCCESS';
export const GET_CUSTOMER_GROUP_ADMINS_SUCCESS =
  'GET_CUSTOMER_GROUP_ADMINS_SUCCESS';
export const DELETE_CUSTOMER_GROUP_MEMBER_SUCCESS =
  'DELETE_CUSTOMER_GROUP_MEMBER_SUCCESS';
export const DELETE_CUSTOMER_GROUP_ADMIN_SUCCESS =
  'DELETE_CUSTOMER_GROUP_ADMIN_SUCCESS';
export const DELETE_CUSTOMER_GROUP_SUCCESS = 'DELETE_CUSTOMER_GROUP_SUCCESS';

// Invitations
export const GET_INVITATIONS = 'GET_INVITATIONS';
export const DELETE_INVITATION = 'DELETE_INVITATION';

// Table
export const SET_TABLE_SEARCH_SUCCESS = 'SET_TABLE_SEARCH_SUCCESS';
export const SET_TABLE_PAGE_SUCCESS = 'SET_TABLE_PAGE_SUCCESS';
export const SET_TABLE_SORT_SUCCESS = 'SET_TABLE_SORT_SUCCESS';
export const SET_TABLE_SIZE_PER_PAGE_SUCCESS =
  'SET_TABLE_SIZE_PER_PAGE_SUCCESS';
